export const yes: string = 'Yes';
export const no: string = 'No';
export const editAction: string = 'edit';
export const addAction: string = 'add';
export const viewAction: string = 'view';
export const reviewAction: string = 'review';
export const createAction: string = 'create';
export const reviewassessmentAction: string = 'reviewassessment';
export const viewassessmentAction: string = 'viewassessment';

export const one: string = '1';
export const two: string = '2';
export const three: string = '3';
